module.exports = __webpack_public_path__ + "media/images/mypage_ic-6ad8135d9f247a8ea64cc871c836b9b5.svg";